import { render } from "./EmployeeLastExaminationView.vue?vue&type=template&id=67210430&scoped=true&ts=true"
import script from "./EmployeeLastExaminationView.vue?vue&type=script&lang=ts"
export * from "./EmployeeLastExaminationView.vue?vue&type=script&lang=ts"

import "./EmployeeLastExaminationView.vue?vue&type=style&index=0&id=67210430&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67210430"]])

export default __exports__